export default {"src":"/_next/static/media/ReportingAndAnalytics.3dbe09e0.svg","height":22,"width":24,"blurWidth":0,"blurHeight":0};